import React, { useRef, useMemo, useEffect, useState } from 'react';
import { useTable, useGlobalFilter, useFilters, usePagination } from 'react-table';
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import swal from 'sweetalert'; 
import { Col, Row, Dropdown } from 'react-bootstrap';
import { COLUMNS } from '../jsx/components/table/FilteringTable/ColumnsTechnicians'; // Update path if necessary
import InviteTechnician from '../jsx/constant/AddTechnician';
import EditTechnician from '../jsx/constant/EditTechnician';
//import ShowTechnician from '../jsx/constant/ShowTechnician';
import { useStateContext } from "../context/ContextProvider";
import AddVehicle from '../jsx/constant/AddVehicle';
import '../jsx/components/table/FilteringTable/filtering.css';

export const TechnicianExpenses = () => {
  const navigate = useNavigate();

  const columns = useMemo(() => COLUMNS, []);
  const [data, setData] = useState([]);
  const [data2, setData2] = useState([]);

  const { user, id, token, permissions } = useStateContext();
  
  // Modal References
  const inviteModalAdd = useRef();
  const inviteModalEdit = useRef();
  const inviteModalShow = useRef();
  const inviteModalVehicle = useRef();
  
  // Fetch technicians data
  const fetchTechnicians = async () => {
    try {
      const response = await axios.get('https://subk.education.com.ly/back/api/technicians'); // Update URL as needed
      setData(response.data);
    } catch (error) {
      console.error("Error fetching technicians:", error);
    }
  };
  
  useEffect(() => {
    fetchTechnicians();
  }, []);

  const handleDeleteTechnician = async (e, id) => {
    e.preventDefault();
    swal({
      title: "هل متأكد من الحدف",
      text: "في حال حدف الملف لايمكنك استعادة هدا الملف",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(willDelete => {
      if (willDelete) {
        axios.delete(`https://subk.education.com.ly/back/api/technicians/${id}`)
          .then(() => {
            fetchTechnicians();
            swal({
              title: "تم",
              text: "تم الحدف بنجاح",
              icon: "success",
              timer: 2000,
              button: false
            });
          })
          .catch(error => {
            console.error("Error deleting technician:", error);
            swal("حدث خطأ أثناء الحدف");
          });
      } else {
        swal("تم الغاء عملية الحدف");
      }
    });
  };

  const handleEditData = (id) => {
    const technician = data.find(item => item.TechnicianID === id);
    if (technician) {
      inviteModalEdit.current.showInviteModal();
      setData2(technician)
      //inviteModalEdit.current.setData(technician); // Assuming setData is a method to set the technician data in the modal
    }
  };

  const handleShowData = (id) => {
    const technician = data.find(item => item.TechnicianID === id);
    if (technician) {
      inviteModalShow.current.showInviteModal();
      inviteModalShow.current.setData(technician); // Assuming setData is a method to set the technician data in the modal
    }
  };

  // Table instance
  const tableInstance = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0 }
    },
    useFilters,
    useGlobalFilter,
    usePagination
  );

  const { 
		getTableProps, 
		getTableBodyProps, 
		headerGroups, 
		prepareRow,
		state,
		page,
		gotoPage,
		pageCount,
		pageOptions,
		nextPage,
		previousPage,
		canNextPage,
		canPreviousPage,
		setGlobalFilter,
	} = tableInstance
    const {globalFilter, pageIndex} = state
 
  return (
    <>
         <Row>
          <Col lg="12">
                 <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">   
                     <div>
                      <Link to="#" className="btn btn-primary btn-sm ms-1" 
                        onClick={() => inviteModalAdd.current.showInviteModal()}> 
                        + إضافة فني 
                      </Link>
                    </div>
                 </div>
                
                <div className="table-responsive">
                  <table {...getTableProps()} className="table dataTable display table-hover" >
                     <thead style={{ position: "sticky", top: 0,  zIndex: 1 }}>                      

                    {headerGroups.map(headerGroup => (
												<tr {...headerGroup.getHeaderGroupProps()}>
												      {headerGroup.headers.map((column) => (
                        // Check if the column accessor is 'age' and render accordingly
                        column.id !== 'TechnicianID' ? (
                          <th {...column.getHeaderProps()}>
                            {column.render('Header')}
                            {column.canFilter ? column.render('Filter') : null}
                          </th>
                        ) : null
                      ))}
												</tr>
										))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                    {page.map((row) => {
                                            prepareRow(row)
                                            return(
                                                <tr {...row.getRowProps()}>

                                                    {row.cells.map((cell) => (
          // Check if the column accessor is 'age' and render accordingly
          cell.column.id !== 'TechnicianID' ? (
            <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
          ) :null
        ))}
                           
                            <td>
                              <Dropdown>
                                <Dropdown.Toggle variant="success" className="sharp i-false">
                                  <i className="fa-solid fa-ellipsis-v"></i>
                                </Dropdown.Toggle>
                                <Dropdown.Menu dir="rtl" className="dropdown-menu-right">
                                 
                                  <Dropdown.Item onClick={() => handleEditData(row.original.TechnicianID)}>
                                    تعديل
                                  </Dropdown.Item>
                              
                                </Dropdown.Menu>
                              </Dropdown>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                  
                  <div className="d-flex justify-content-between mx-2">
                    <span>
                      الصفحة <strong>{pageIndex + 1} من {pageOptions.length}</strong>
                    </span>
                    <span className="table-index">
                      اذهب الى:
                      <input type="number" 
                        className="ml-2" 
                        defaultValue={pageIndex + 1} 
                        onChange={e => {
                          const pageNumber = e.target.value ? Number(e.target.value) - 1 : 0;
                          gotoPage(pageNumber);
                        }} 
                      />
                    </span>
                  </div>
                  <div className="text-center mb-3">  
                                        <div className="filter-pagination  mt-3">
                                            <button className="previous-button" onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
                                                {/* {'<'} */}
                                                <i className='fa-solid fa-angle-right' />
                                            </button>
                                            
                                            <button className="previous-button" onClick={() => previousPage()} disabled={!canPreviousPage}>
                                                السابق
                                            </button>
                                            <button className="next-button" onClick={() => nextPage()} disabled={!canNextPage}>
                                                التالي
                                            </button>
                                            <button className="next-button" onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
                                                {/* {'>'} */}
                                                <i className='fa-solid fa-angle-left' />
                                            </button>
                                        </div>
                                    </div>
               </div>
            </Col>
        </Row>
 
      <InviteTechnician ref={inviteModalAdd} parentFunction={fetchTechnicians} />
      <EditTechnician ref={inviteModalEdit} data={data2} parentFunction={fetchTechnicians} />

    </>
  );
}

export default TechnicianExpenses;
